import { observer } from 'mobx-react-lite'
import { AuthorizationDocumentCommon } from 'pages/settings/ui/AuthorizationDocumentCommon'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useTextEnableLandlineContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'

export const AuthorizationDocument = observer(() => {
  const { authorizationDocumentStore, nextClickHandler } = useTextEnableLandlineContext()
  return (
    <>
      <AuthorizationDocumentCommon authorizationDocumentStore={authorizationDocumentStore} />
      <NextButton text='Next' onClick={nextClickHandler} />
    </>
  )
})
